let isProduction = process.env.VUE_APP_NAME === 'production';
export function getOS() {
  let sUserAgent = navigator.userAgent;
  let isWin = navigator.platform == "Win32" || navigator.platform == "Windows";
  let isMac =
    navigator.platform == "Mac68K" ||
    navigator.platform == "MacPPC" ||
    navigator.platform == "Macintosh" ||
    navigator.platform == "MacIntel";
  if (isMac) return "Mac";
  let isUnix = navigator.platform == "X11" && !isWin && !isMac;
  if (isUnix) return "Unix";
  let isLinux = String(navigator.platform).indexOf("Linux") > -1;
  if (isLinux) return "Linux";
  if (isWin) {
    let isWin2K =
      sUserAgent.indexOf("Windows NT 5.0") > -1 ||
      sUserAgent.indexOf("Windows 2000") > -1;
    if (isWin2K) return "Win2000";
    let isWinXP =
      sUserAgent.indexOf("Windows NT 5.1") > -1 ||
      sUserAgent.indexOf("Windows XP") > -1;
    if (isWinXP) return "WinXP";
    let isWin2003 =
      sUserAgent.indexOf("Windows NT 5.2") > -1 ||
      sUserAgent.indexOf("Windows 2003") > -1;
    if (isWin2003) return "Win2003";
    let isWinVista =
      sUserAgent.indexOf("Windows NT 6.0") > -1 ||
      sUserAgent.indexOf("Windows Vista") > -1;
    if (isWinVista) return "WinVista";
    let isWin7 =
      sUserAgent.indexOf("Windows NT 6.1") > -1 ||
      sUserAgent.indexOf("Windows 7") > -1;
    if (isWin7) return "Win7";
    let isWin8 =
      sUserAgent.indexOf("windows NT 6.2") > -1 ||
      sUserAgent.indexOf("Windows 8") > -1;
    if (isWin8) return "Win8";
    let isWin10 =
      sUserAgent.indexOf("Windows NT 10") > -1 ||
      sUserAgent.indexOf("Windows 10") > -1;
    if (isWin10) return "Win10";
    let isWin11 =
      sUserAgent.indexOf("Windows NT 11") > -1 ||
      sUserAgent.indexOf("Windows 11") > -1;
    if (isWin11) return "Win11";
  }
  return "other";
}
export function getDownLoad(sys) {
  const prodDownload =
    'https://jingyingbang-client.obs.cn-east-3.myhuaweicloud.com/GongDui/Prod/%E7%BB%8F%E8%90%A5%E5%B8%AE%E5%B7%A5%E9%98%9F.exe';
  const testDownload =
    'https://jingyingbang-client.obs.cn-east-3.myhuaweicloud.com/GongDui/Test/%E7%BB%8F%E8%90%A5%E5%B8%AE%E5%B7%A5%E9%98%9F.exe';
    let latWin10_url = '';
    // win10及以上版本
    let gtWin10_url = '';
    latWin10_url = isProduction ? prodDownload : testDownload;
    gtWin10_url = isProduction ? prodDownload : testDownload;
  const winEnum = {
    Win2000: latWin10_url,
    WinXP: latWin10_url,
    Win2003: latWin10_url,
    WinVista: latWin10_url,
    Win7: latWin10_url,
    Win8: latWin10_url,
    Win10: gtWin10_url,
    Win11: gtWin10_url,
    Mac: latWin10_url,
    Unix: latWin10_url,
    Linux: latWin10_url
  }
 return winEnum[sys]
}